import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import { unmask, updateMask as updateMaskCash } from '@/helpers/masks/cashNumber';
import validators from '@/helpers/validators';
import useForm from '@/hooks/useForm';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import api from '@/services/api';
import { EventProducer } from '@/model/EventProducer';
import { ProducerFeeContainer } from './ui';
import { FormInput } from '../types';

export const ProducerFeeScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const { formData, formErrors, onChangeFormInput, isFormValid } = useForm({
    initialData: {
      calcAdmFee: 'false',
      pdv: '',
      generalCommission: 'true',
      credit: '',
      installment: '',
      debit: '',
      pix: '',
      bankslip: '',
      food: '',
      technical: '',
      trip: '',
      rentPos: '',
      courtesyIssuance: '',
      cashSaleDashboard: '',
      ticketCancellations: '',
      blockMap: '',
      releaseMap: '',
      ticketRoll: '',
      calcAdmFeeProduct: 'false',
      pdvProduct: '',
      generalCommissionProduct: 'true',
      creditProduct: '',
      installmentProduct: '',
      debitProduct: '',
      pixProduct: '',
      bankSlipProduct: '',
      foodProduct: '',
      technicalProduct: '',
      tripProduct: '',
      rentPosProduct: '',
      courtesyIssuanceProduct: '',
      cashSaleDashboardProduct: '',
      ticketCancellationsProduct: '',
      ticketRollProduct: '',
    },
    validators: {
      calcAdmFee: [validators.required],
      pdv: [validators.required],
      generalCommission: [validators.required],
      credit: [validators.required],
      installment: [validators.required],
      debit: [validators.required],
      pix: [validators.required],
      bankslip: [validators.required],
      food: [validators.required],
      technical: [validators.required],
      trip: [validators.required],
      rentPos: [validators.required],
      courtesyIssuance: [validators.required],
      cashSaleDashboard: [validators.required],
      ticketCancellations: [validators.required],
      blockMap: [validators.required],
      releaseMap: [validators.required],
      ticketRoll: [validators.required],
      calcAdmFeeProduct: [validators.required],
      pdvProduct: [validators.required],
      generalCommissionProduct: [validators.required],
      creditProduct: [validators.required],
      installmentProduct: [validators.required],
      debitProduct: [validators.required],
      pixProduct: [validators.required],
      bankSlipProduct: [validators.required],
      foodProduct: [validators.required],
      technicalProduct: [validators.required],
      tripProduct: [validators.required],
      rentPosProduct: [validators.required],
      courtesyIssuanceProduct: [validators.required],
      cashSaleDashboardProduct: [validators.required],
      ticketCancellationsProduct: [validators.required],
      ticketRollProduct: [validators.required],
    },
    formatters: {
      pdv: updateMaskCash,
      credit: updateMaskCash,
      installment: updateMaskCash,
      debit: updateMaskCash,
      pix: updateMaskCash,
      bankslip: updateMaskCash,
      food: updateMaskCash,
      technical: updateMaskCash,
      trip: updateMaskCash,
      rentPos: updateMaskCash,
      courtesyIssuance: updateMaskCash,
      cashSaleDashboard: updateMaskCash,
      ticketCancellations: updateMaskCash,
      blockMap: updateMaskCash,
      releaseMap: updateMaskCash,
      ticketRoll: updateMaskCash,
      pdvProduct: updateMaskCash,
      creditProduct: updateMaskCash,
      installmentProduct: updateMaskCash,
      debitProduct: updateMaskCash,
      pixProduct: updateMaskCash,
      bankSlipProduct: updateMaskCash,
      foodProduct: updateMaskCash,
      technicalProduct: updateMaskCash,
      tripProduct: updateMaskCash,
      rentPosProduct: updateMaskCash,
      courtesyIssuanceProduct: updateMaskCash,
      cashSaleDashboardProduct: updateMaskCash,
      ticketCancellationsProduct: updateMaskCash,
      ticketRollProduct: updateMaskCash,
    },
  });

  const handleOnFecth = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventProducer>('/producer-fee');
      if (data.pdv) {
        onChangeFormInput(FormInput.calcAdmFee)(`${data.calcAdmFee}`);
        onChangeFormInput(FormInput.pdv)(`${Number(data.pdv) * 100}`);
        onChangeFormInput(FormInput.generalCommission)(data.generalCommission ? 'true' : 'false');
        onChangeFormInput(FormInput.credit)(`${Number(data.credit) * 100}`);
        onChangeFormInput(FormInput.installment)(`${Number(data.installment) * 100}`);
        onChangeFormInput(FormInput.debit)(`${Number(data.debit) * 100}`);
        onChangeFormInput(FormInput.pix)(`${Number(data.pix) * 100}`);
        onChangeFormInput(FormInput.bankslip)(`${data.bankslip}`);
        onChangeFormInput(FormInput.food)(`${data.food}`);
        onChangeFormInput(FormInput.technical)(`${data.technical}`);
        onChangeFormInput(FormInput.trip)(`${data.trip}`);
        onChangeFormInput(FormInput.rentPos)(`${data.rentPos}`);
        onChangeFormInput(FormInput.courtesyIssuance)(`${data.courtesyIssuance}`);
        onChangeFormInput(FormInput.cashSaleDashboard)(`${data.cashSaleDashboard}`);
        onChangeFormInput(FormInput.ticketCancellations)(`${data.ticketCancellations}`);
        onChangeFormInput(FormInput.blockMap)(`${data.blockMap}`);
        onChangeFormInput(FormInput.releaseMap)(`${data.releaseMap}`);
        onChangeFormInput(FormInput.ticketRoll)(`${data.ticketRoll}`);
        onChangeFormInput(FormInput.calcAdmFeeProduct)(`${data.calcAdmFeeProduct}`);
        onChangeFormInput(FormInput.pdvProduct)(`${Number(data.pdvProduct) * 100}`);
        onChangeFormInput(FormInput.generalCommissionProduct)(
          data.generalCommissionProduct ? 'true' : 'false',
        );
        onChangeFormInput(FormInput.creditProduct)(`${Number(data.creditProduct) * 100}`);
        onChangeFormInput(FormInput.installmentProduct)(`${Number(data.installmentProduct) * 100}`);
        onChangeFormInput(FormInput.debitProduct)(`${Number(data.debitProduct) * 100}`);
        onChangeFormInput(FormInput.pixProduct)(`${Number(data.pixProduct) * 100}`);
        onChangeFormInput(FormInput.bankSlipProduct)(`${data.bankSlipProduct}`);
        onChangeFormInput(FormInput.foodProduct)(`${data.foodProduct}`);
        onChangeFormInput(FormInput.technicalProduct)(`${data.technicalProduct}`);
        onChangeFormInput(FormInput.tripProduct)(`${data.tripProduct}`);
        onChangeFormInput(FormInput.rentPosProduct)(`${data.rentPosProduct}`);
        onChangeFormInput(FormInput.courtesyIssuanceProduct)(`${data.courtesyIssuanceProduct}`);
        onChangeFormInput(FormInput.cashSaleDashboardProduct)(`${data.cashSaleDashboardProduct}`);
        onChangeFormInput(FormInput.ticketCancellationsProduct)(
          `${data.ticketCancellationsProduct}`,
        );
        onChangeFormInput(FormInput.ticketRollProduct)(`${data.ticketRollProduct}`);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleOnSave = async (): Promise<void> => {
    if (isFormValid()) {
      try {
        setState(States.loading);
        const payload: EventProducer = {
          calcAdmFee: formData[FormInput.calcAdmFee] === 'true',
          pdv: Number(unmask(formData[FormInput.pdv])),
          generalCommission: formData[FormInput.generalCommission] === 'true',
          credit: Number(unmask(formData[FormInput.credit])),
          installment: Number(unmask(formData[FormInput.installment])),
          debit: Number(unmask(formData[FormInput.debit])),
          pix: Number(unmask(formData[FormInput.pix])),
          bankslip: Number(unmask(formData[FormInput.bankslip])),
          food: Number(unmask(formData[FormInput.food])),
          technical: Number(unmask(formData[FormInput.technical])),
          trip: Number(unmask(formData[FormInput.trip])),
          rentPos: Number(unmask(formData[FormInput.rentPos])),
          courtesyIssuance: Number(unmask(formData[FormInput.courtesyIssuance])),
          cashSaleDashboard: Number(unmask(formData[FormInput.cashSaleDashboard])),
          ticketCancellations: Number(unmask(formData[FormInput.ticketCancellations])),
          blockMap: Number(unmask(formData[FormInput.blockMap])),
          releaseMap: Number(unmask(formData[FormInput.releaseMap])),
          ticketRoll: Number(unmask(formData[FormInput.ticketRoll])),
          calcAdmFeeProduct: formData[FormInput.calcAdmFeeProduct] === 'true',
          pdvProduct: Number(unmask(formData[FormInput.pdvProduct])),
          generalCommissionProduct: formData[FormInput.generalCommissionProduct] === 'true',
          creditProduct: Number(unmask(formData[FormInput.creditProduct])),
          installmentProduct: Number(unmask(formData[FormInput.installmentProduct])),
          debitProduct: Number(unmask(formData[FormInput.debitProduct])),
          pixProduct: Number(unmask(formData[FormInput.pixProduct])),
          bankSlipProduct: Number(unmask(formData[FormInput.bankSlipProduct])),
          foodProduct: Number(unmask(formData[FormInput.foodProduct])),
          technicalProduct: Number(unmask(formData[FormInput.technicalProduct])),
          tripProduct: Number(unmask(formData[FormInput.tripProduct])),
          rentPosProduct: Number(unmask(formData[FormInput.rentPosProduct])),
          courtesyIssuanceProduct: Number(unmask(formData[FormInput.courtesyIssuanceProduct])),
          cashSaleDashboardProduct: Number(unmask(formData[FormInput.cashSaleDashboardProduct])),
          ticketCancellationsProduct: Number(
            unmask(formData[FormInput.ticketCancellationsProduct]),
          ),
          ticketRollProduct: Number(unmask(formData[FormInput.ticketRollProduct])),
        };
        await api.post<EventProducer>('/producer-fee', payload);
        await handleOnFecth();
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err.message);
      } finally {
        setState(States.default);
      }
    }
  };

  useEffect(() => {
    handleOnFecth();
  }, []);

  return (
    <ProducerFeeContainer
      state={state}
      formData={formData}
      onChangeFormInput={onChangeFormInput}
      formErrors={formErrors}
      onSave={handleOnSave}
    />
  );
};
